<div class="btn-group select-site" dropdown>
    <button data-cy="select-site" class="btn btn-default dropdown-toggle fill" [disabled]="disabled" dropdownToggle type="button">
        <span *ngIf="!selectedSite">Select Site</span>
        <span *ngIf="selectedSite">
            Site {{ selectedSite.siteNumber }} &ndash; {{ selectedSite.siteName }}
        </span>
        <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" *dropdownMenu role="menu">
        <li *ngFor="let site of sites">
            <a [attr.data-cy]="site.siteName" class="dropdown-item" (click)="selectSite(site)">
                {{ site.siteNumber }} &ndash; {{ site.siteName }}
            </a>
        </li>
    </ul>
</div>
